"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spatnavClassNameAttrs = void 0;

/**
 * Добавляет класс `sn-section-item`, необходимый для работы @salutejs/spatial
 */
var spatnavClassNameAttrs = {
  className: 'sn-section-item'
};
exports.spatnavClassNameAttrs = spatnavClassNameAttrs;